<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const SportsIcon = getIcon("SportsIcon");
</script>

{#if typeof SportsIcon === 'string'}
	<img src={SportsIcon} alt={$t(Verbiage.sports_icon_alt, 'alts')} />
{:else if typeof SportsIcon === 'function'}
	<svelte:component this={SportsIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
